<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add On AIR Video</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update On AIR Video</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addOnAirForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Heading</label>
                                        <input class="form-control" id="heading" formControlName="heading"
                                               placeholder="Heading"/>
                                        <small *ngIf="submitted && addOnAirForm.get('heading').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="frame_url">Frame Url</label>
                                        <textarea class="form-control resize-none" rows="3" id="frame_url"
                                                  formControlName="frame_url">
                                        </textarea>
                                        <small *ngIf="submitted && addOnAirForm.get('frame_url').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="duration">Duration</label>
                                        <input class="form-control" id="duration" formControlName="duration"
                                               placeholder="e.g. PT4M13S for 4 min 13 sec"/>
                                        <small class="form-text text-muted">
                                            ISO 8601 format: PT[hours]H[minutes]M[seconds]S — e.g. 4:13 is PT4M13S.
                                        </small>
                                        <small *ngIf="submitted && addOnAirForm.get('duration').hasError('pattern')"
                                               class="text-danger">
                                            Must be in ISO 8601 duration format, e.g. PT4M13S.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" rippleEffect class="btn btn-danger" data-dismiss="modal"
                                            aria-label="Close" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>
